import React, { useState } from 'react';
import { Button, Input } from '@fourthwall/components';
import { SearchIcon } from '@fourthwall/icons';
import { validateDomain } from '../../utils/validateDomain';
import * as S from './SearchDomainInput.styled';
export const SearchDomainInput = ({ isSearching, onSearch }) => {
    const [value, setValue] = useState('');
    const [showError, setShowError] = useState(false);
    const getErrorMessage = () => {
        if (!showError)
            return;
        if (!validateDomain(value)) {
            return 'Please enter a valid domain';
        }
    };
    const handleSearch = () => {
        setShowError(true);
        if (!validateDomain(value))
            return;
        onSearch(value);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };
    return (React.createElement(S.Container, null,
        React.createElement(Input, { size: "medium", placeholder: "Type the domain you want", value: value, leftIcon: SearchIcon, fullWidth: true, error: getErrorMessage(), onKeyDown: handleKeyDown, onValueChange: setValue }),
        React.createElement(Button, { label: "Search", loading: isSearching, onClick: handleSearch })));
};
